import {GuideModelV1} from 'resources/GeneratedModels/Guide/GuideModel.v1';

import {extensions} from './guide.extensions';

GuideModelV1.extend(extensions);

export {GuideModelV1};
